/* NOTE THAT These enums are interfaces are copied from the component library (component/utils/icons) */
export enum NgZorroIconTheme {
  TwoTone = 'twotone',
  Outline = 'outline',
  Fill = 'fill'
}
